app.controller('BrowseProductListStockController', ['$rootScope', '$scope', function ($rootScope, $scope) {

    if ($scope.orderride_navigation_ids) {
        $scope.navigation_ids = $scope.orderride_navigation_ids;
    }
    const navigationIDs = $scope.navigation_ids;

    $scope.product_model = $rootScope.factory.product_stock.getModel(navigationIDs);

    if (navigationIDs.product_id) {
        $scope.getBackBtnTxt = function () {
            return null;
        }
    }


    $scope.product_document = null;
    $scope.product_document_text = "";

    let documentProductTags = [];
    if(navigationIDs.parent_category_group_id){
        documentProductTags = [navigationIDs.parent_category_group_id];
        if(navigationIDs.parent_category_group_id === "promotional_sample"){
            $scope.product_document_text = "Download Samples PDF"
        }

    }

    if(documentProductTags.length){
        $rootScope.service.cache_local_server.productDocumentsByTags(documentProductTags, function (documents) {
            $scope.product_document = documents.length > 0 ? documents[0] : null;
        })
    }

    $scope.selected_list_filter = navigationIDs.alpha_category_id && navigationIDs.alpha_category_id !== "all" ? navigationIDs.alpha_category_id : null;

    $scope.product_model.apiRequire();

    $scope.addToCartHandler = function (validateFormCallback, product) {
        const categoryCartID = $scope.category_cart_id ? $scope.category_cart_id : null;

        const complexOption = $rootScope.service.option_product.currentComplexOption(product);

        const orderLine = {

            type: "stock",
            product_code: product.api_code,

            quantity: product.quantity,
            cost: product.displayPrice(),

            range: product.getSubmitRangeID(),
            colour: navigationIDs.colour_id,
            style: navigationIDs.style_id,

            option_id: complexOption.id,
            jpull_position: product.jpull_position ? product.jpull_position.value : null,

            height: product.height,
            width: product.width,
            length: product.length,
            depth: product.depth,

            rotate_grain: product.rotate_grain,


            hinge_holes: $rootScope.service.product.collectHingeHoles(product),

            category_cart_id: categoryCartID,

            product_model_id: product.model_id,
            parent_category_ids: product.parent_category_ids,

            group_name: product.group_name
        };

        const orderBuild = {
            range: orderLine.range,
            colour: orderLine.colour,
            style: orderLine.style,
            lines: [orderLine]
        };


        $rootScope.service.product.addToCart(orderBuild, function (success, messages) {
            if (success) {
                $rootScope.service.product.resetProduct(product);
            }
            if (validateFormCallback) {
                validateFormCallback(success, messages);
            }
        });

    };

    $scope.showStyleWithProductName = function (product) {
        if (!product.requires_style) {
            return false;
        }
        return !$scope.navigation_values.style_name || !product.name.includes($scope.navigation_values.style_name);
    }

    $scope.list_item_include = "views/browse/product/browse-product-item-stock.htm";
    $scope.list_current_txt = "Current Category";


}]);